/**
 * Lightweight wrapper around Auth.required() that avoids pulling auth.js
 * into the initial bundle. For logged-in users (the common case), this
 * just checks App.isLoggedIn and calls onAuthorize() synchronously.
 * For logged-out users, it dynamically imports auth.js to show the
 * login modal.
 */

interface RequireAuthOptions {
   from?: string;
   message?: string;
   onAuthorize: () => void;
   onCancel?: () => void;
   reload?: boolean;
   close?: boolean;
   register?: boolean;
   stayInWindow?: boolean;
   ignoreSSO?: boolean;
}

export function requireAuth(options: RequireAuthOptions): boolean {
   if (App.isLoggedIn) {
      options.onAuthorize?.();
      return true;
   }

   if (options.reload) {
      options.onAuthorize = () => {};
   }

   void import('Shared/auth').then(({ Auth }) => {
      Auth.required(options);
   });

   return false;
}
